export const tarotCheckoutUrl = 'https://kit-profesional-de-tarot-terapeutico-portal.impultienda.ar/checkout'

export function getTarotCheckoutUrl() {
  if (typeof window === 'undefined') return tarotCheckoutUrl

  const checkoutUrl = new URL(tarotCheckoutUrl)
  const currentUrl = new URL(window.location.href)

  currentUrl.searchParams.forEach((value, key) => {
    checkoutUrl.searchParams.set(key, value)
  })

  return checkoutUrl.toString()
}

export function redirectToTarotCheckout() {
  window.location.assign(getTarotCheckoutUrl())
}
